/* eslint-disable react/no-unused-prop-types */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
// import moment from 'moment'
import { format } from 'date-fns'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import CardHeader from 'components/CardHeader'
import Tooltip from 'react-toolbox/lib/tooltip'
import Link from 'react-toolbox/lib/link'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./BankTransfersList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)
const TooltipLink = Tooltip(Link)

class BankTransferList extends Component {
  static propTypes = {
    bankTransfers: PropTypes.instanceOf(Array),
    header: PropTypes.string,
  }
  static defaultProps = {
    bankTransfers: [],
    header: '',
  }
  renderCols = () => {
    return (
      <tr>
        <th className={classnames(styles.table.narrowLeft10, styles.table.narrowHeight, headerStyles)}>
          From
        </th>
        <th className={classnames(styles.table.flushLeft, styles.table.narrowHeight, headerStyles)}>
          Type
        </th>
        <th className={classnames(styles.table.flushLeft, styles.table.narrowHeight, headerStyles)}>
          Amount
        </th>
        <th className={classnames(styles.table.flushLeft, styles.table.narrowHeight, headerStyles)}>
          Transfer date
        </th>
      </tr>
    )
  }

  renderData = () => {
    return this.props.bankTransfers.length ? (
      this.props.bankTransfers.slice(0, 5).map((btr, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${btr.banktransferauditreport_id}-${i}`}>
          <td className={classnames(styles.table.narrow, styles.table.narrowHeight)}>
            <TooltipLink active className={classnames(styles.tip)} label={btr.FromAccountNo} tooltip={`Requested by: ${btr.RequestedBy}\nTo account name: ${btr.ToAccountName}`} />
          </td>
          <td className={classnames(styles.table.flushLeft, styles.table.narrowHeight)}>{btr.TransferRequestType}</td>
          <td className={classnames(styles.table.flushLeft, styles.table.narrowHeight)}>{`${btr.TotalAmount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })}`}</td>
          <td className={classnames(styles.table.flushLeft, styles.table.narrowHeight)}>
            {(btr.DateRequested ? format(new Date(btr.DateRequested), constants.DATE_FORMAT.STANDARD_AU_TIME) : '')}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={4}>
          <div className={styles.noAccountsAndLoans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <CardHeader
            narrowPadding
            title="Last 5 transfers"
          />
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default BankTransferList



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/BankTransfersList.js